import { render, staticRenderFns } from "./JouleLawViz.vue?vue&type=template&id=2adb113a&scoped=true"
import script from "./JouleLawViz.vue?vue&type=script&lang=js"
export * from "./JouleLawViz.vue?vue&type=script&lang=js"
import style0 from "./JouleLawViz.vue?vue&type=style&index=0&id=2adb113a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adb113a",
  null
  
)

export default component.exports